import type { TFunction } from 'i18next';
import type { AuditLogEntry } from '@/api/audit/auditApi.types';
import { SIGN_IN_FAILED_ACTION } from '@/constants/activityLog';

function hasText(value: string | null): value is string {
  return value !== null && value.trim().length > 0;
}

export function describeActivityAction(entry: AuditLogEntry, t: TFunction): string {
  return t('activity:action.' + entry.action, { defaultValue: t('activity:action.unknown') });
}

export function describeActivityActor(entry: AuditLogEntry, t: TFunction): string {
  if (hasText(entry.actorName)) {
    return entry.actorName;
  }
  if (hasText(entry.actorEmail)) {
    return entry.actorEmail;
  }
  if (entry.action === SIGN_IN_FAILED_ACTION) {
    return t('activity:actor.unknownAccount');
  }
  return t('activity:actor.system');
}

export function describeActivitySubjects(
  entry: AuditLogEntry,
  t: TFunction,
  includeClient: boolean = true
): string[] {
  const subjects: string[] = [];
  if (entry.subjectPatientId !== null) {
    const patientName = hasText(entry.patientName)
      ? entry.patientName
      : t('activity:subject.removedPatient');
    subjects.push(t('activity:subject.patient', { name: patientName }));
  }
  if (includeClient === true && entry.subjectClientId !== null) {
    const clientName = hasText(entry.clientName)
      ? entry.clientName
      : t('activity:subject.removedClient');
    subjects.push(t('activity:subject.client', { name: clientName }));
  }
  return subjects;
}

export function describeActivityDevice(entry: AuditLogEntry, t: TFunction): string | null {
  const browser = entry.deviceBrowser;
  const operatingSystem = entry.deviceOperatingSystem;
  if (hasText(browser) && hasText(operatingSystem)) {
    return t('activity:device.browserOnSystem', { browser, system: operatingSystem });
  }
  if (hasText(browser)) {
    return browser;
  }
  if (hasText(operatingSystem)) {
    return operatingSystem;
  }
  return null;
}
